<mat-card class="content-card">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <mat-card-title>
        </mat-card-title>
        <div fxFlex></div>
        <a mat-raised-button color="primary" routerLink="new">Add user</a>
    </mat-card-header> 
  <app-mat-table-generator #table tableName="usersTable" 
  [useEmbededFilter]="true" 
  [columns]="columns" 
  [dataSource]="dataSource"
  [multiselectEnabled]="false"
  [undoDeleteEnabled]="false"
  [viewEnabled]="false"
  [editLink]="getEditLink">
  </app-mat-table-generator>
</mat-card>